module.exports = __webpack_public_path__ + "img/column_yuedu.b52b90e3.png";